(function () {
    'use strict';

    var controller = function () {
        var ctrl = this;
        var _init = false;

        ctrl.$onInit = init;
        ctrl.$onChanges = change;
        //-
        function setToggle(value) {
            // If there's an event, fire that, otherwise set the model
            if (typeof ctrl.onCheck === 'function') {
                ctrl.onCheck({ $event: { value: value } });
            } else {
                ctrl.modelCtrl.$setViewValue(value, 'checkbox.js::toggleCheckbox');
            }
        };

        ctrl.toggleCheckbox = function () {
            if (!ctrl.disabled && (!ctrl.lockCheck || ctrl.modelCtrl.$viewValue !== ctrl.value)) {
                var value = ctrl.modelCtrl.$viewValue !== ctrl.value ? ctrl.value : false;
                if (!!ctrl.confirm) {
                    global.showConfirm({
                        title: 'Confirm',
                        message: !!value ?
                            (ctrl.confirmString || `Are you sure you want to set ${ctrl.label} to ${ctrl.value}?`) :
                            `Are you sure you want to unset ${ctrl.label}`,
                        ok: 'Yes',
                        cancel: 'No',
                        callback: function (ok) {
                            if (ok) setToggle(value);
                        }
                    });
                } else {
                    setToggle(value);
                }
            }
        };

        //Alias methods
        function change(changes) {
            if (_init) {
            }
        }

        function init() {
            //tiosUtil.log('init checkbox');

            ctrl.value = !tios.util.isNullOrUndefined(ctrl.value) ? ctrl.value : true;

            ctrl.svg = tios.util.getSymbol(!!ctrl.cross ? 'cross' : 'tick');

            _init = true;
        };
    };

    app.component('checkbox', {
        require: { modelCtrl: 'ngModel' },
        bindings: {
            value: '<?',
            label: '@?',

            confirm: '<?',
            confirmString: '@?',

            ghostTick: '<?',

            cross: '<?',

            boxLeft: '<?',

            required: '<?',

            lockCheck: '<?',// Disallow unsetting after check

            disabled: '<?', // Disable clicking completely (also makes ignore required if required is set)

            onCheck: '&?',
        },

        controller: [controller],

        template: '<div ng-click="$ctrl.toggleCheckbox($event)" ng-class="{ \'is-checked\': $ctrl.modelCtrl.$viewValue === $ctrl.value, \'disabled\':!!$ctrl.disabled, \'no-click\': ($ctrl.modelCtrl.$viewValue === $ctrl.value && $ctrl.lockCheck) }"><span class="box" ng-if="!!$ctrl.boxLeft" ng-class="{ \'field-invalid\': $ctrl.required && !$ctrl.disabled && $ctrl.modelCtrl.$viewValue !== $ctrl.value, \'check-cross\': !!$ctrl.cross }"><svg ng-show="$ctrl.modelCtrl.$viewValue === $ctrl.value || !!$ctrl.ghostTick"><use xlink:href="" ng-href="{{::$ctrl.svg}}" /></svg></span><span ng-if="!!$ctrl.label" class="label" ng-bind="$ctrl.label"></span><span class="box" ng-if="!$ctrl.boxLeft" ng-class="{ \'field-invalid\': $ctrl.required && !$ctrl.disabled && $ctrl.modelCtrl.$viewValue !== $ctrl.value, \'check-cross\': !!$ctrl.cross }"><svg ng-show="$ctrl.modelCtrl.$viewValue === $ctrl.value || !!$ctrl.ghostTick"><use xlink:href="" ng-href="{{::$ctrl.svg}}" /></svg></span><input type="hidden" ng-value="$ctrl.modelCtrl.$viewValue !== $ctrl.value ? null : 1" ng-required="$ctrl.required && !$ctrl.disabled" /></div>'
    });

})();